import * as React from "react";
import EditEscalatorRTDGroup from "../../Editing/EditEscalatorRTDGroup";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type EscalatorRTDGroupsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  isLoadingEscalatorRTDGroups: boolean;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.EscalatorSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.EscalatorSubmenu, columnFilter: Filter[]) => void;
};

type EscalatorRTDGroupsTableState = {
  isModalOpen: boolean;
};

export class EscalatorRTDGroupsTable extends React.Component<
  EscalatorRTDGroupsTableProps,
  EscalatorRTDGroupsTableState
> {
  state = {
    isModalOpen: false
  };
  
  componentDidMount(): void {//on load
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingEscalatorRTDGroups } = this.props;
    const { escalatorRTDGroups } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const escalatorRTDGroupRows: Api.EscalatorRTDGroup[] = escalatorRTDGroups;
    let selectedColumns: State.Column[] = [];

    selectedColumns = columns["Escalator RTD Groups"];
    const startingPage = mainState.lastEditedObjectId
      ? (escalatorRTDGroupRows.findIndex(
          escalatorRTDGroup => escalatorRTDGroup.id === mainState.lastEditedObjectId
        ) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={escalatorRTDGroupRows}
            loading={isLoadingEscalatorRTDGroups}
            loadingText="Fetching escalator RTD groups..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEscalatorRTDGroupSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditEscalatorRTDGroup toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
 
  private isEscalatorRTDGroupSelected = (escalatorRTDGroup: Api.EscalatorRTDGroup): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && escalatorRTDGroup.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default EscalatorRTDGroupsTable;